export default function RightArrow() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0012 10.3286C1.17282 10.3197 0.494095 10.984 0.485224 11.8124C0.476353 12.6408 1.1407 13.3195 1.96907 13.3284L2.0012 10.3286ZM19.0492 13.072C19.6413 12.4925 19.6514 11.5428 19.072 10.9508L9.62879 1.30314C9.04931 0.711114 8.09962 0.700943 7.50759 1.28042C6.91556 1.8599 6.90539 2.8096 7.48487 3.40162L15.8788 11.9773L7.30314 20.3712C6.71111 20.9507 6.70094 21.9004 7.28042 22.4924C7.8599 23.0844 8.8096 23.0946 9.40162 22.5151L19.0492 13.072ZM1.96907 13.3284L17.9839 13.4999L18.0161 10.5001L2.0012 10.3286L1.96907 13.3284Z"
        fill="black"
      />
    </svg>
  );
}
